import {hasHiddenUnicodeCharacters, showHiddenUnicodeCharactersRaw} from '@github-ui/hidden-unicode-banner/utils'
import type {DiffLine} from '../types'
import {showHiddenUnicodeCharactersHTML} from '@github-ui/hidden-unicode-banner/HiddenUnicodeCharacter'
import type {SafeHTMLString} from '@github-ui/safe-html'

export const processLineForHiddenUnicode = (line: DiffLine, showHiddenUnicode: boolean): DiffLine => {
  let hasHiddenUnicode = false
  let updatedLine = line

  hasHiddenUnicode = hasHiddenUnicodeCharacters(line.text)

  updatedLine = {...updatedLine, hasHiddenUnicode}

  if (showHiddenUnicode && hasHiddenUnicode) {
    if (line.html) {
      updatedLine = {
        ...updatedLine,
        /* eslint-disable-next-line @github-ui/github-monorepo/no-cast-as-safe-html-string */
        html: showHiddenUnicodeCharactersHTML(line.html as SafeHTMLString) ?? line.html,
      }
    } else {
      updatedLine = {...updatedLine, text: showHiddenUnicodeCharactersRaw(line.text)}
    }
  }

  return updatedLine
}
